import BrandingColorsModel from "./BrandingColorsModel";
import BrandingImagesModel from "./BrandingImagesModel";
import BrandingUrlsModel from "./BrandingUrlsModel";

export default class BrandingModel {
  public colors: BrandingColorsModel = null;
  public urls: BrandingUrlsModel = null;
  public images: BrandingImagesModel = null;
}
